<script>
  import { fade } from 'svelte/transition';
  import UserStore from '../stores/user';
  import fetchData from '../api.js';
  import {link, push} from 'svelte-spa-router'
  import { locale, _ } from 'svelte-i18n';
  import { onMount } from 'svelte';
  import { allowed_stores , storeNames , apply_store_list } from '../variables';
  import Popup from '../components/Popup.svelte';
  import Header from '../components/Header.svelte'; 
  import Preloader from '../components/Preloader.svelte';
  
  let isLoading = true;

  export let params = {};

  let back_link = '/store/' + params.store_id;

  let store_id = params.store_id;
  let note_id = params.note_id;
  let barcode = '';
  let popupActive = false;
  let popupAlertActive = false;
  let destination = '';

  let note = {
    DeliveryLine : []
  }

  let stores = localStorage.getItem('stores');
  stores = JSON.parse(stores);

  let store_name = storeNames[store_id];

  let scannedItems = {}

  onMount(async() => {

    if (!$UserStore || !$UserStore.data){
      push('/login');
      return;
    }    

    const formData = {
        store : store_id,
        note : note_id,
        action : 'get_delivery_note',
        token : $UserStore.data
    }

    let data = await fetchData(formData);

    isLoading = false;

    if (data.success==1) {
      
      note = data.data

      barcode = note_id;

      if (apply_store_list.indexOf(store_id)!==-1) {
          barcode = (`${store_id}`).padStart(3,0) + (`${note_id}`).padStart(6,0);
      }

      note.movement_store_from = '';//destination;

      console.log('note.DeliveryLine',note.DeliveryLine)

      if (typeof note.DeliveryLine === 'object') {
        note.DeliveryLine = [note.DeliveryLine];
      }    

      document.addEventListener('keydown', handleKeyDown);
      
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };

    }

  });

  let scannedBarcode = '';

  function handleKeyDown(event) {
    // Check if the key pressed is a number or Enter
    if (/^\d$/.test(event.key)) {
      scannedBarcode += event.key;
    } else if (event.key === 'Enter') {

      console.log('scannedBarcode',scannedBarcode)

      const note = document.getElementById('note' + scannedBarcode);

      if (!note) {
        // Handle the case when the note does not exist
        alert('תעודה לא קיימת ברשימה');
        scannedBarcode = '';
        return;
      }

      const dataIndex = note.getAttribute('data-index');
      const dataNote= note.getAttribute('data-note');
      const dataDestination = note.getAttribute('data-destination');
      const dataStore = note.getAttribute('data-store');
      const dataStatus = note.getAttribute('data-status');

      scannedItems[notesType][dataNote] = {
        barcode : scannedBarcode,
        destination : dataDestination,
        note : dataNote,
        store : dataStore,
        status : dataStatus,
      }

      const selectedNote = notes_types[notesType].splice(dataIndex, 1)[0];      
      selectedNote.scanned = true;
      notes_types[notesType].unshift(selectedNote);

      console.log(notes_types[notesType])

      notes_types = { ...notes_types};

      scannedBarcode = '';
    }
  }

  const removeSelectedNote = (e) => {



    delete scannedNotes[notesType][e.detail.note];

    notes_types[notesType][e.detail.index].scanned = false      

    notes_types = { ...notes_types};

    scannedNotes = { ...scannedNotes};
    
  }

  const ClosePopup = (e) => {

    popupActive = false;
    popupAlertActive = false;

  }

  const ApprovePopup= async(e) => {

    //console.log('destination',destination)

    if (destination=='') {
      popupAlertActive = true;
      popupActive = false;
      return;
    }

    let formData = {
        notes : [],    
        action : 'update_delivery_note',
        token : $UserStore.data,
        name : $UserStore.name
    }

   

    let store = store_id;    
    let original_status = note.status;
    let status = 3;

    if (apply_store_list.includes(store)) {
        if (apply_store_list.includes(destination)) {
            status = 6;
            if (original_status==6) {
                status = 3;
            }
        }

    }

    if ([69,70,79,390,65].includes(store)) {
        store = 1;
    }
    

    formData.notes.push({
        store : store,
        destination :destination,
        note : note_id,
        status :status
    })

    let data = await fetchData(formData);
    if (data.success==1) {
      popupActive = false


      formData = {
          merchant_id : $UserStore.id,
          action : 'set_log',
          notes : formData.notes,
          name : $UserStore.name,
          url : 'https://yehuda.dreamax.co.il/api/rest/set_log'
      }

      data = await fetchData(formData);
    }
   
  }


</script>

<style>
.grid{
  display: flex;
}
.grid > div{
  flex: 1;
  text-align: right;
  padding: 8px 20px;
  border: 1px solid #575757;
  background-color: #000000;
  color: #fff;
  /* border-radius: 54px; */
  margin: 0px;
  position: relative;
  opacity: 0.6;
}
.grid > div .counter.empty {
  background-color: #575757;
} 
.scanned {
  background-color: aqua;;
}
.approve_button {
  margin-top: 15px;
  padding: 15px 20px;
  background-color: #FFCF01;
  color: black;
  border: none;
  border-radius: 40px;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  margin:auto;
  text-decoration: none;
  text-align:center;
  margin-top: 10px;
}
.page-title {
  background: #000;
  color: #fff;
  padding: 10px
}
.title {
    font-size: 20px;;
    font-weight: bold;
}
.content {
  font-size: 15px;
  margin: 15px 0 5px;
  font-weight: bold;
}
.item {
  display: flex;;
  padding: 20px 20px;
  border-bottom:1px solid #f1f1f1;
  font-size: 15px;;
  justify-content:space-between;
  align-items: center;;
}
.subtitle {
  padding:10px 20px;
  border-bottom:1px solid #f1f1f1;
  background: #e2e2e2;
    font-weight: bold;
  
}
.selectbox {
  width:100%;
  padding:10px;
  box-sizing: border-box;;
}
.selectbox select{
  padding:15px 10px;
  box-sizing: border-box;
  width:100%;
  border-radius: 40px;
}
</style>
<Preloader isLoading={isLoading} />
<Header {back_link}/>
<Popup popupActive={popupAlertActive} on:ClosePopup={ClosePopup}>
  <div slot="title" class="title">{$_('note.alert_title')}</div>
  <div slot="content" class="content">{$_('note.alert_no_destination')}</div>
</Popup>
<Popup {popupActive} approveActive="true" on:ClosePopup={ClosePopup} on:ApprovePopup={ApprovePopup}>
  <div slot="title" class="title">{$_('store.approve_title')}</div>
  <div slot="content" class="content">{$_('store.approve_content')}</div>
</Popup>
<div class="page" transition:fade={{ delay: 250, duration: 300 }}>
  <div class="page-title title">{$_('note.note_number')} {barcode}</div> 
  {#if Object.keys(storeNames).length}
  <div class="selectbox">
    <select bind:value={destination}>
      <option value="">{$_('note.choose destination')}</option>
      {#each Object.keys(storeNames) as store_id}
      <option value="{store_id}">
        {storeNames[store_id]}
      </option>
      {/each}
    </select>
    <div class="approve_button" on:click={ ()=> { popupActive = true; } }>{$_('note.approve')}</div>
  </div>
  {/if}
  <div class="notes"> 
    {#if note.DeliveryLine.length}  
      <div class="subtitle">{$_('note.items')}</div> 
      {#each note.DeliveryLine as item,index(item)}    
        {#if item.ItemId}
            <div class="item" data-lineno="{item.LineNo}">
                {$_('note.sku')}: {item.ItemId} <br>
                {$_('note.name')}: {item.ItemDesc} <br>
                {$_('note.qty')}: {item.Qty} <br>
            </div>
          {/if}
      {/each}
    {/if}
  </div>  
</div>
